import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export abstract class BaseWorkflowRule extends BaseEntityModel {
  abstract get ruleId(): string | undefined;
}
